<dx-popup
  [width]="570"
  [(visible)]="showModal"
  [height]="'auto'"
  [showTitle]="true"
  [title]="'PUBLISHING-MODE-REQUIRED.TITLE' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  (onHidden)="onClose()"
>
  <div *dxTemplate="let data of 'content'">
    <div class="publishing-mode-required">
      <p class="publishing-mode-required-description">
        {{ 'PUBLISHING-MODE-REQUIRED.DESCRIPTION' | translate }}
      </p>

      <a
        class="publishing-mode-link"
        (click)="onGoToPublishingMode()"
      >
        {{ 'PUBLISHING-MODE-REQUIRED.GO-TO-PUBLISHING-MODE' | translate }}
      </a>

      <div class="publishing-mode-actions">
        <dx-button
          type="normal"
          [width]="100"
          [text]="'COMMON.OK' | translate"
          (click)="onClose()"
        ></dx-button>
      </div>
    </div>
  </div>
</dx-popup>